import React from "react";
import PropTypes from "prop-types";

import LoadingSpinner from "../../../shared_components/loading_spinner";

class AllDataSection extends React.Component {
  render () {
    return (
      <div className="main">
        <div className="row">
          <div className="filter-area col-md-12">
            a bunch of filters
          </div>
        </div>

        <div className="row">
          <div className="all-data-table col-md-12">
            <div>all data table</div>

            <LoadingSpinner show={this.props.isLoading}/>
          </div>
        </div>
      </div>
    );
  }
}

AllDataSection.propTypes = {
  isLoading: PropTypes.bool.isRequired
};

export default AllDataSection;
